import React, { useState } from 'react';
import { graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import classNames from 'classnames';

import LanguageDropdown from './LanguageDropdown';
import { LanguageConsumer } from '../context/LanguageContext';
import NavigationMenuMobile from './NavigationMenuMobile';
import { UserConsumer } from '../context/UserContext';
import QueryHandler from '../misc/QueryHandler';
import FormattedMessageWrappedInSpan from '../misc/FormattedMessageWrappedInSpan';

import { trackEvent } from '../../utils/ga-tracking';

////////////////////////////////////////////
// TODO MISSING TESTS
////////////////////////////////////////////

const SportografNavigationBar = (props) => {
  const { location, match } = props;
  const transparentNavigation =
    location.pathname === `/${match.params.language}` ||
    location.pathname === `/${match.params.language}/about`;

  const [mobileExpanded, setMobileExpanded] = useState(false);
  const [mobileAccountExpanded, setMobileAccountExpanded] = useState(false);
  const [mobileLanguageExpanded, setMobileLanguageExpanded] = useState(false);

  const handleMobileExpand = () => {
    if (mobileExpanded) {
      document.body.style.overflow = 'initial';
    } else {
      document.body.style.overflow = 'hidden';
    }

    setMobileExpanded((prevState) => !prevState);
    setMobileAccountExpanded(false);
    setMobileLanguageExpanded(false);
  };

  const hideMobileMenu = () => {
    setMobileExpanded(false);
    setMobileAccountExpanded(false);
    setMobileLanguageExpanded(false);

    document.body.style.overflow = 'initial';
  };

  const handleMobileAccountDropdown = () => {
    if (mobileExpanded) {
      setMobileAccountExpanded((prevState) => !prevState);
    }
  };

  const handleMobileLanguageDropdown = () => {
    if (mobileExpanded) {
      setMobileLanguageExpanded((prevState) => !prevState);
    }
  };

  return (
    <LanguageConsumer>
      {({ language, onLanguageChange }) => (
        <UserConsumer>
          {({ isLoggedIn, onLoginChange }) => (
            <div
              className={classNames('navigation-bar-container-outer', {
                'navigation-bar-transparent': transparentNavigation,
              })}
            >
              <section
                className={classNames(
                  'navigation-bar-container',
                  'container-full-width',
                  'container-960',
                  {
                    'mobile-expanded': mobileExpanded,
                  }
                )}
              >
                <Link className="navigation-bar-logo" to="/">
                  <img src="/images/sg-logo-new-no-text.png" />
                  <span>SPORTOGRAF</span>
                </Link>
                <div className="navigation-bar-items-container">
                  <div onClick={hideMobileMenu} className="navigation-bar-item">
                    <QueryHandler
                      hasLoadingIndicator={false}
                      query={graphql`
                        query SportografNavigationBarQuery {
                          viewer {
                            cart {
                              lineItems {
                                id
                              }
                            }
                          }
                        }
                      `}
                      render={(props) => {
                        const { cart } = props.viewer;
                        if (cart) {
                          return (
                            <Link
                              className="navigation-bar-checkout"
                              to="/cart"
                              onClick={() =>
                                trackEvent('Navigation', 'Checkout', 'Cart icon')
                              }
                            >
                              <span data-count={cart.lineItems.length} />
                            </Link>
                          );
                        }
                        return null;
                      }}
                      shouldHandleError={false}
                    />
                  </div>
                  <div className="navigation-bar-items">
                    <div className="navigation-bar-item" onClick={hideMobileMenu}>
                      <Link className="navigation-bar-home" to="/:language">
                        <FormattedMessageWrappedInSpan
                          id="navigationBar.homeItem"
                          defaultMessage="Home"
                        />
                      </Link>
                    </div>
                    {isLoggedIn && (
                      <div
                        className={classNames(
                          'navigation-bar-item',
                          'navigation-bar-account',
                          {
                            'dropdown-expanded': mobileAccountExpanded,
                          }
                        )}
                      >
                        <div
                          className="navigation-bar-dropdown-main"
                          onClick={handleMobileAccountDropdown}
                        >
                          <FormattedMessageWrappedInSpan
                            id="navigationBar.accountItem"
                            defaultMessage="My Account"
                          />
                        </div>
                        <div className="navigation-bar-dropdown">
                          <div
                            className="navigation-bar-dropdown-item"
                            onClick={hideMobileMenu}
                          >
                            <Link to="/account/events">
                              <FormattedMessageWrappedInSpan
                                id="navigationBar.account.myEventsItem"
                                defaultMessage="My photos"
                              />
                            </Link>
                          </div>
                          <div
                            className="navigation-bar-dropdown-item"
                            onClick={hideMobileMenu}
                          >
                            <Link to="/account/orders">
                              <FormattedMessageWrappedInSpan
                                id="navigationBar.account.myOrdersItem"
                                defaultMessage="My invoices"
                              />
                            </Link>
                          </div>
                          <div
                            className="navigation-bar-dropdown-item"
                            onClick={hideMobileMenu}
                          >
                            <Link to="/account/rechecks">
                              <FormattedMessageWrappedInSpan
                                id="navigationBar.account.myRechecksItem"
                                defaultMessage="My reviews"
                              />
                            </Link>
                          </div>
                          <div
                            className="navigation-bar-dropdown-item"
                            onClick={() => {
                              onLoginChange(false);
                              hideMobileMenu();
                            }}
                          >
                            <Link to="/">
                              <FormattedMessageWrappedInSpan
                                id="navigationBar.account.logoutItem"
                                defaultMessage="Logout"
                              />
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="navigation-bar-item" onClick={hideMobileMenu}>
                      <Link className="navigation-bar-about" to="/about">
                        <FormattedMessageWrappedInSpan
                          id="navigationBar.aboutItem"
                          defaultMessage="About Us"
                        />
                      </Link>
                    </div>
                    <LanguageDropdown
                      language={language}
                      onLanguageChange={onLanguageChange}
                      handleMobileLanguageDropdown={handleMobileLanguageDropdown}
                      mobileLanguageExpanded={mobileLanguageExpanded}
                      hideMobileMenu={hideMobileMenu}
                    />
                  </div>
                </div>
                <NavigationMenuMobile handleMobileExpand={handleMobileExpand} />
              </section>
            </div>
          )}
        </UserConsumer>
      )}
    </LanguageConsumer>
  );
};

SportografNavigationBar.propTypes = {
  viewer: PropTypes.object,
  match: PropTypes.object,
  location: PropTypes.object,
};

export default withRouter(SportografNavigationBar);
